/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {UpdateOwnableParams} from 'create-components/OwnableConstants';
import OwnableSettingsModal from 'create-components/OwnableSettingsModal';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {CreateTemplateParams} from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import TemplateCollectionDAO from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import notifications from 'notifications';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
}

class CreateTemplateCollectionModal extends React.Component<Props> {
  createCollection({
    name,
    description,
    owner,
    collaborators,
    ownerInfo,
  }: CreateTemplateParams): JQueryPromise<any> {
    return TemplateCollectionDAO.create({name, description, owner, collaborators, ownerInfo})
      .always(() => {
        $('#fileLoading').addClass('hidden');
      })
      .done((templateCollectionResponse) => {
        writeFragmentsToCache(getFragmentWrapper('TemplateCollectionSummary'), [
          {
            __typename: 'TemplateCollectionNode',
            ...templateCollectionResponse,
          },
        ]);
      })
      .fail(notifications.notifyError);
  }

  render(): JSX.Element {
    return (
      <OwnableSettingsModal
        onRequestClose={this.props.onRequestClose}
        ownableType={ModelTypeConstants.TEMPLATE_COLLECTION}
        doSubmit={(data: UpdateOwnableParams) =>
          this.createCollection({...data, collaborators: data.collaborators!})
        }
      />
    );
  }
}

export default CreateTemplateCollectionModal;
